export function getdata() {
	let obj = {
		searchlist: [{
				prop: "zhongfkm",
				label: '中方科目',
				type: "select",
				selectval: [],
			},
			{
				prop: "cain",
				label: '财年',
				type: "select",
				selectval: [],
			},
		],
		searchdata: {
			zhongfkm: '',
			cain: '',
		},
		headData: [{
				title: "财年",
				prop: "cain",
				width: "100"
			},
			{
				title: "期间",
				prop: "qij",
				width: "100"
			},
			{
				title: "年初余额",
				prop: "niancye",
				width: "100",
				AmountFormat: true,
			},
			{
				title: "本年累计借方",
				prop: "benbbnljjfje",
				width: "100",
				AmountFormat: true,
				custom: true
			},
			{
				title: "本年累计贷方",
				prop: "benbbnljdfje",
				width: "100",
				AmountFormat: true,
				custom: true
			},
			{
				title: "本期借方",
				prop: "benbjfje",
				width: "100",
				AmountFormat: true,
				custom: true
			},
			{
				title: "本期贷方",
				prop: "benbdfje",
				width: "100",
				AmountFormat: true,
				custom: true
			},
			{
				title: "本期期末余额",
				prop: "sumjine",
				width: "100",
				AmountFormat: true,
				custom: true
			},
			// {
			// 	title: "当月余额",
			// 	prop: "monthJe",
			// 	AmountFormat: true,
			// 	width: "100"
			// }


		],

	}
	return obj
}
